import { Box, Button } from "@chakra-ui/react"
import React from "react"

import { Account } from "../container/account"

export function DisconnectButton() {
    const {
        actions: { logout },
    } = Account.useContainer()

    return (
        <Button isFullWidth onClick={logout}>
            <Box color="red.500">Disconnect</Box>
        </Button>
    )
}
